import { useTranslation } from 'next-i18next';

import { useAuth } from '@restworld/feature-authentication';
import { Tabs, TabItem } from '@restworld/ui-ds-base';

import { AccountSettingsTab } from './account-settings-tab';
import { UserNotificationTab } from './user-notification-tab';
import SaveResearchTab from './save-research-tab';
import { useFetchWorkerDataQuery } from '../../../hooks';

export const UserSettingsTabs = () => {
  const { t } = useTranslation('user-settings');
  const { user } = useAuth();
  useFetchWorkerDataQuery();
  const newTabs: TabItem[] = [
    {
      label: t('page_tabs_account'),
      content: <AccountSettingsTab />,
    },
    {
      label: t('page_tabs_notifications'),
      content: <UserNotificationTab />,
      disabled: user?.type === 'lead',
    },
    {
      label: t('page_tabs_research'),
      content: <SaveResearchTab />,
    },
  ];
  return (
    <div className="flex flex-col">
      <Tabs tabs={newTabs} />
    </div>
  );
};
